/* eslint-disable react/display-name */
/**
 * @file ParametersManagementView.jsx
 * @author Fernando Ruano
 * @description Parameters Management View Page
 */

// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Helpers
import { sortString } from '@nephro/commons/helpers/utils';

// Components
import ManagementCrud from '@nephro/components/ManagementCrud';

/**
 * Parameters Management View
 * @param { Object } parameterActions - Parameter Actions.
 * @return { Node } React node.
 */
function ParametersManagementView({ parameterActions }) {
  const { t: translate } = useTranslation();
  const { getParametersArray, deleteParameterById } = parameterActions;

  // Table columns
  const columns = [
    {
      title: translate('paramMg.key'),
      dataIndex: 'param_key',
      sorter: sortString('param_key')
    },
    {
      title: translate('paramMg.value'),
      dataIndex: 'param_value',
      sorter: sortString('param_value')
    },
    {
      title: translate('commons.description'),
      dataIndex: 'param_description',
      sorter: sortString('param_description')
    }
  ];

  return (
    <div className="h-full">
      <ManagementCrud
        getItemsArray={getParametersArray}
        deleteItemById={deleteParameterById}
        columns={columns}
        deleteConfirmText={'paramMg.deleteParameter'}
        createButtonText={'paramMg.create'}
        itemIdKey={'id'}
      />
    </div>
  );
}

/**
 * Component definition of proptypes.
 */
ParametersManagementView.propTypes = {
  actions: PropTypes.shape({
    setLoading: PropTypes.func.isRequired
  }).isRequired,
  parameterActions: PropTypes.shape({
    getParametersArray: PropTypes.func.isRequired,
    deleteParameterById: PropTypes.func.isRequired
  }).isRequired,
  user: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]).isRequired,
  loading: PropTypes.bool
};

export default ParametersManagementView;
